export const INCOME_TAX = [
  {
    title: 'Income Tax e-Filing',
    permalink: '/income-tax-efiling',
  },
  {
    title: 'Income Tax Calculator',
    permalink: '/paytax/taxcalculator',
  },
  {
    title: 'Income Tax Slabs FY 2025-26',
    permalink: '/s/income-tax-slabs',
  },
  {
    title: 'Old vs New Tax Regime',
    permalink: '/s/old-tax-regime-vs-new-tax-regime',
  },
  {
    title: 'How To File ITR',
    permalink: '/s/how-to-efile-itr',
  },
  {
    title: 'New Tax Regime',
    permalink: '/s/section-115bac-features-new-tax-regime-benefits',
  },
  {
    title: 'Which ITR Should I File',
    permalink: '/s/which-itr-to-file',
  },
  {
    title: 'Last Date To File ITR For 2025-26',
    permalink: '/s/due-date-tax-filing',
  },
  {
    title: 'Income Tax Sections & Deductions',
    permalink: '/s/80c-80-deductions',
  },
  {
    title: 'Income Tax Refund',
    permalink: '/s/income-tax-refund',
  },
  {
    title: 'Capital Gains Income',
    permalink: '/s/capital-gains-income',
  },
  {
    title: 'TDS',
    permalink: '/s/tds',
  },
  {
    title: 'PF Balance Check',
    permalink: '/s/pf-balance-check',
  },
  {
    title: 'Form 26AS',
    permalink: '/s/view-form-26as-tax-credit-statement',
  },
  {
    title: 'Advance Tax',
    permalink: '/s/advance-tax',
  },
  {
    title: 'Budget 2026 Highlights',
    permalink: '/s/budget-2026-highlights',
  },
];

export const INCOME_TAX_B2B = [
  {
    title: 'GST',
    permalink: '/s/gst-law-goods-and-services-tax',
  },
  {
    title: 'GST Registration',
    permalink: '/s/gst-registration',
  },
  {
    title: 'Input Tax Credit (ITC)',
    permalink: '/s/gst-input-tax-credit',
  },
  {
    title: 'e-Invoicing',
    permalink: '/s/e-invoicing-gst',
  },
  {
    title: 'e-Way Bill',
    permalink: '/s/eway-bill-gst-rules-compliance',
  },
  {
    title: 'GST Returns',
    permalink: '/s/gst-returns',
  },
  {
    title: 'TDS',
    permalink: '/s/tds',
  },
  {
    title: 'Enterprise Compliance',
    permalink: '/s/compliance',
  },
  {
    title: 'Invoice Discounting (ID)',
    permalink: 'https://www.clear.in/s/invoice-discounting',
  },
  {
    title: 'Vendor Management',
    permalink: '/s/vendor-management',
  },
  {
    title: 'Accounts Payable (AP)',
    permalink: 'https://www.clear.in/s/accounts-payable',
  },
  {
    title: 'Supply Chain',
    permalink: '/s/supply-chain',
  },
];

export const PERSONAL_FINANCE = [
  {
    title: 'Income Tax e-Filing',
    permalink: '/income-tax-efiling',
  },
  {
    title: 'Income Tax Slabs FY 2025-26',
    permalink: '/s/income-tax-slabs',
  },
  {
    title: 'How To File ITR',
    permalink: '/s/how-to-efile-itr',
  },
  {
    title: 'Which ITR Should I File',
    permalink: '/s/which-itr-to-file',
  },
  {
    title: 'Last Date To File ITR For 2025-26',
    permalink: '/s/due-date-tax-filing',
  },
  {
    title: 'Old vs New Tax Regime',
    permalink: '/s/old-tax-regime-vs-new-tax-regime',
  },
  {
    title: 'Aadhaar Card',
    permalink: '/s/aadhaar-card',
  },
  {
    title: 'Pan Card',
    permalink: '/s/pan-card',
  },
  {
    title: 'SBI KYC Update',
    permalink: '/s/sbi-kyc-update-online',
  },
  {
    title: 'APAAR ID Card',
    permalink: '/s/apaar-id-card',
  },
  {
    title: 'Aadhaar Card Pan Card Link Status',
    permalink: '/s/how-to-check-aadhar-card-pan-card-link-status',
  },
  {
    title: '8th Pay Commission',
    permalink: '/s/8th-pay-commission',
  },
  {
    title: 'UPI Transaction Charges',
    permalink: '/s/upi-transaction-charges',
  },
  {
    title: 'PM Surya Ghar Muft Bijli Yojana',
    permalink: '/s/rooftop-solar-scheme',
  },
  {
    title: 'Aadhaar Card Link with Mobile Number Status Check',
    permalink: '/s/aadhaar-card-link-with-mobile-number-check',
  },
];
